// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"32":"b06f88a8d3cb0e0568b9","898":"39963590dd610bd5c1b5"}[chunkId] + ".js";
};